import { Box, Container, ContainerProps } from "@mui/material";
import ScreenHeader from "./ScreenHeader";

type ScreenContentsProps = ContainerProps;

export function ScreenContents(props: ScreenContentsProps) {
  return <Container maxWidth="sm" sx={{ p: 0 }} {...props} />;
}

type Props = {
  title: string;
  children: React.ReactNode;
  headerAction?: React.ReactNode;
  showBack?: boolean;
  // where back goes when there is no in-app history (e.g. a deep link)
  backFallback?: string;
  showNotifications?: boolean;
  maxWidth?: ContainerProps["maxWidth"];
};

export default function Screen({
  title,
  children,
  headerAction,
  showBack,
  backFallback,
  showNotifications,
  maxWidth,
}: Props) {
  return (
    <Box sx={{ pb: 4 }}>
      <ScreenHeader
        action={headerAction}
        enableBackNavigation={showBack}
        backFallback={backFallback}
        hideNotifications={!showNotifications}
      >
        {title}
      </ScreenHeader>
      <ScreenContents maxWidth={maxWidth || "sm"}>{children}</ScreenContents>
    </Box>
  );
}
